export default __webpack_public_path__ + "static/media/produto.5785294b.png";